const setting = () =>
    import ('@/views/setting/setting/index.vue');
const staff = () =>
    import ('@/views/setting/staff/index.vue');
const groups = () =>
    import ('@/views/setting/groups/index.vue');
const taskGroup = () =>
    import ('@/views/setting/taskGroup/index.vue');
const app = () =>
    import ('@/views/setting/app/index.vue');
const onOff = () =>
    import ('@/views/setting/on-off/index.vue');
const time = () =>
    import ('@/views/setting/time/index.vue');
const messageTag = () =>
    import ('@/views/setting/messageTag/index.vue');
const consultClassify = () =>
    import ('@/views/setting/consultClassify/index.vue');

export default [
      // 设置
      {
        path: "/setting",
        name: "setting",
        components: {
            default: setting,
        },
        meta: {
            nav: "setting",
            navChild: "setting",
            
            keepAlive: true
        },
    },
    {
        path: "/setting/staff",
        name: "staff",
        components: {
            default: staff,
        },
        meta: {
            nav: "setting",
            navChild: "staff",
            navName:"用户管理",
            keepAlive: true
        },
    },
    {
        path: "/setting/taskGroup",
        name: "taskGroup",
        components: {
            default: taskGroup,
        },
        meta: {
            nav: "setting",
            navChild: "taskGroup",
            navName:"工单组管理",
            keepAlive: true
        },
    },
    {
        path: "/setting/groups",
        name: "groups",
        components: {
            default: groups,
        },
        meta: {
            nav: "setting",
            navChild: "groups",
            navName:"客服组管理",
            keepAlive: true
        },
    },
    {
        path: "/setting/app",
        name: "app",
        components: {
            default: app,
        },
        meta: {
            nav: "setting",
            navChild: "app",
            navName:"应用管理",
            keepAlive: true
        },
    },
    {
        path: "/setting/onOff",
        name: "onOff",
        components: {
            default: onOff,
        },
        meta: {
            nav: "setting",
            navChild: "onOff",
            navName:"基础配置",
            keepAlive: true
        },
    },
    {
        path: "/setting/time",
        name: "time",
        components: {
            default: time,
        },
        meta: {
            nav: "setting",
            navChild: "time",
            navName:"时间计划",
            keepAlive: true
        },
    },
    {
        path: "/setting/messageTag",
        name: "messageTag",
        components: {
            default: messageTag,
        },
        meta: {
            nav: "setting",
            navChild: "messageTag",
            navName:"标签管理",
            keepAlive: true
        },
    },
    {
        path: "/setting/consultClassify",
        name: "consultClassify",
        components: {
            default: consultClassify,
        },
        meta: {
            nav: "setting",
            navChild: "consultClassify",
            navName:"咨询分类管理",
            keepAlive: true
        },
    },
]



// WEBPACK FOOTER //
// ./src/views/setting/index.js